<template>
  <div class="col s12 l6">
    <div>
      <div class="page-subtitle">
        <h4>{{'Create' | localize}}</h4>
      </div>

      <form @submit.prevent="submitHandler">
        <div class="input-field">
          <input
            id="name"
            type="text"
            v-model.trim="CategoryName"
            :class="{invalid: $v.CategoryName.$dirty && !$v.CategoryName.required}"
          />
          <label for="name">{{'Title' | localize}}</label>
          <span
            v-if="$v.CategoryName.$dirty && !$v.CategoryName.required"
            class="helper-text invalid"
          >{{'Message_CategoryTitle' | localize}}</span>
        </div>

        <div class="input-field">
          <input
            id="limit"
            type="number"
            v-model.number="CategoryLimit"
            :class="{invalid: ($v.CategoryLimit.$dirty && !$v.CategoryLimit.minValue) || ($v.CategoryLimit.$dirty && !$v.CategoryLimit.required)}"
          />
          <label for="limit">{{'Limit' | localize}}</label>
          <span
            v-if="$v.CategoryLimit.$dirty && !$v.CategoryLimit.required"
            class="helper-text invalid"
          >{{'Message_CategoryLimit' | localize}}</span>
          <span
            class="helper-text invalid"
            v-if="$v.CategoryLimit.$dirty && !$v.CategoryLimit.minValue"
          >{{'Message_MinLength' | localize}}: {{$v.CategoryLimit.$params.minValue.min}}</span>
        </div>

        <button class="btn waves-effect waves-light" type="submit">
          {{'Create' | localize}}
          <i class="material-icons right">create</i>
        </button>
      </form>
    </div>
  </div>
</template>

<script>
import { required, minValue } from "vuelidate/lib/validators";
import localizeFilter from "@/filters/localize.filter";

export default {
  name: "CategoryCreate",
  data: () => ({
    CategoryName: "",
    CategoryLimit: 100
  }),
  validations: {
    CategoryName: { required },
    CategoryLimit: { required, minValue: minValue(100) }
  },
  mounted() {
    window.M.updateTextFields();
  },
  methods: {
    async submitHandler() {
      if (this.$v.$invalid) {
        this.$v.$touch();
        return;
      }

      try {
        const category = await this.$store.dispatch("createCategory", {
          title: this.CategoryName,
          limit: this.CategoryLimit
        });
        (this.CategoryName = ""), (this.CategoryLimit = "");
        this.$v.$reset();
        this.$message(localizeFilter("Category_HasBeenCreated"));
        await this.$emit("created", category);
        window.M.updateTextFields();
      } catch (e) {}
    }
  }
};
</script>